import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getEbayTaskResultFile = createAsyncThunk('ebay/getEbayTaskResultFile',
  async ({ taskId, account, type }, { rejectWithValue }) => {
  // result_file, input_file
    try {
      const { data } = await authGet(`/ebay/task/${taskId}/${type}`, {
        params: { account }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getEbayTaskResultFile;
